module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kb-La.ac782737.png";